export { default as Img200 } from './processed/200/Avengers-Infinity-Wars.jpg';
export { default as Img400 } from './processed/400/Avengers-Infinity-Wars.jpg';
export { default as Imgthumb } from './processed/thumb/Avengers-Infinity-Wars.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Avengers-Infinity-Wars.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Avengers-Infinity-Wars.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      197,
      92,
      32
    ],
    "_population": 348,
    "_hsl": [
      0.0606060606060606,
      0.7205240174672489,
      0.44901960784313727
    ]
  },
  "LightVibrant": {
    "_rgb": [
      237,
      217,
      160
    ],
    "_population": 938,
    "_hsl": [
      0.12337662337662335,
      0.6814159292035399,
      0.7784313725490196
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      12,
      59,
      127
    ],
    "_population": 2059,
    "_hsl": [
      0.5985507246376812,
      0.8273381294964028,
      0.27254901960784317
    ]
  },
  "Muted": {
    "_rgb": [
      170,
      95,
      77
    ],
    "_population": 1903,
    "_hsl": [
      0.032258064516129045,
      0.3765182186234818,
      0.484313725490196
    ]
  },
  "LightMuted": {
    "_rgb": [
      202,
      169,
      189
    ],
    "_population": 223,
    "_hsl": [
      0.8989898989898989,
      0.23741007194244593,
      0.7274509803921568
    ]
  },
  "DarkMuted": {
    "_rgb": [
      101,
      45,
      56
    ],
    "_population": 1988,
    "_hsl": [
      0.9672619047619048,
      0.3835616438356164,
      0.28627450980392155
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Avengers-Infinity-Wars.js